import { cn } from "@/lib/utils";

import { StatusVariant } from "../../types";

const VARIANT_STYLES: Record<StatusVariant, { dot: string; bg: string; text: string; border: string }> = {
  pending: { dot: "bg-yellow-500", bg: "bg-yellow-50", text: "text-yellow-700", border: "border-yellow-200" },
  approved: { dot: "bg-green-600", bg: "bg-green-50", text: "text-green-700", border: "border-green-200" },
  rejected: { dot: "bg-red-500", bg: "bg-red-50", text: "text-red-700", border: "border-red-200" },
  closed: { dot: "bg-gray-400", bg: "bg-gray-50", text: "text-gray-600", border: "border-gray-200" },
  inactive: { dot: "bg-gray-400", bg: "bg-gray-50", text: "text-gray-500", border: "border-gray-200" },
  resubmission: { dot: "bg-orange-500", bg: "bg-orange-50", text: "text-orange-700", border: "border-orange-200" },
  default: { dot: "bg-blue-500", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200" },
};

interface StatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant: StatusVariant;
  children: React.ReactNode;
  className?: string;
}

export function StatusBadge({
  variant,
  children,
  className,
  ...rest
}: StatusBadgeProps): JSX.Element {
  const style = VARIANT_STYLES[variant];

  return (
    <span
      {...rest}
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        style.bg,
        style.text,
        style.border,
        className,
      )}
    >
      <span className={cn("mr-1.5 h-2 w-2 rounded-full", style.dot)} />
      {children}
    </span>
  );
}

export type { StatusVariant };
